export default __webpack_public_path__ + "resources/icons/d311-6b1c.png";